// DS: i5.4
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
// this is used in shared/FaveButton/FavingIcon
export function getFavouriteIconMarkup(className) {
    return /*#__PURE__*/ React.createElement("path", {
        className: className,
        d: "M11.054 3a1 1 0 00-.87.506L8.123 7.134l-4.57.641a1 1 0 00-.812.68l-.545 1.672a1 1 0 00.266 1.038l3.264 3.07-.765 4.33a1 1 0 00.416.997l1.567 1.081a1 1 0 001.021.069L12 18.66l4.116 2.07a1 1 0 001.025-.074l1.524-1.072a1 1 0 00.408-.999l-.8-4.35 3.257-3.063a1 1 0 00.261-1.052l-.564-1.65a1 1 0 00-.807-.666l-4.58-.643-2.066-3.653a1 1 0 00-.87-.508h-1.85z"
    });
}
const FavStarFill = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, getFavouriteIconMarkup()));
FavStarFill.displayName = 'FavStarFill';
export default FavStarFill;
